import React, { useEffect, useRef, useState } from "react";
import style from "../shared/skeleton.module.css";
import { config as axiosConfig } from "../shared/config";
import axios from "axios";

const BotStats = () => {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(false);
  const ref = useRef(false);

  const getBotStats = async () => {
    const config = {
      headers: {
        Authorization: `Bearer ${axiosConfig.bearerToken}`,
      },
    };

    setLoading(true);
    try {
      const res = await axios.get(`${axiosConfig.baseUrl}/bot/stats`, config);
      if (res.data.stats) {
        setStats(res.data.stats);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("Bot Stats Error:", error);
    }
  };

  useEffect(() => {
    if (!ref.current) {
      getBotStats();
      ref.current = true;
    }
  }, []);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full">
      {loading
        ? [1, 2].map(() => (
            <div className={`h-28`}>
              <div className={`h-10 ${style.skeleton_box} mb-1`}></div>
              <div className="grid grid-cols-3 gap-1">
                <div className={`${style.skeleton_box} h-16`}></div>
                <div className={`${style.skeleton_box} h-16`}></div>
                <div className={`${style.skeleton_box} h-16`}></div>
              </div>
            </div>
          ))
        : stats.length
        ? stats.map((stat, idx) => (
            <Stat key={idx} stat={stat} isLive={stat.isLive} />
          ))
        : ""}
    </div>
  );
};

const Stat = ({ stat, isLive }) => {
  return (
    <div
      className={`${
        isLive
          ? "bg-[rgba(255,255,255,0.5)]"
          : "bg-[rgba(255,85,84,0.5)] text-white"
      } shadow-md font-unilever-shilling-medium px-2`}
    >
      <div
        className={`!border-b-2 !border-[rgba(255,255,255,0.5)] text-center py-2 text-[16px]`}
      >
        {stat.heading}
      </div>
      <div className="grid grid-cols-3">
        {stat.values.map((value, idx) => (
          <div
            key={idx}
            className={`${
              idx !== stat.values.length - 1
                ? "!border-r-2 !border-[rgba(0,0,0,0.08)]"
                : ""
            } flex flex-col justify-center items-center p-2`}
          >
            <div className="text-[14px]">{value.count}</div>
            <div className="text-[10px]">{value.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BotStats;

